import { Bill } from '@/interfaces/Bill';
import { fetch } from '@/utils/fetch';
import { buildQueryString } from '@/utils/queryParams';

interface Props {
  outletId: string;
  tableNumber: string;
  amount?: number;
  selectedTipPercentage?: number;
  signal?: AbortSignal;
  locale?: string;
}

export const getTableDetails = ({
  outletId,
  tableNumber,
  amount,
  selectedTipPercentage,
  signal,
  locale,
}: Props): Promise<Bill> => {
  const queryString = buildQueryString({
    amount: amount !== undefined && amount > 0 ? amount : undefined,
    tipPercentage: selectedTipPercentage,
    isServiceFeeEnabled: true,
    language: locale,
  });

  const url = `/personalization-public/dine-in/outlets/${outletId}/tables/${tableNumber}${queryString ? `?${queryString}` : ''}`;

  return fetch.get(url, { signal }).then(response => response.data);
};
